<template>
  <div class="row" style="overflow-y:scroll;height:100vh">
    <div
      class="col-md-9 col-sm-12 bg"
      :style="{ backgroundImage: 'url(' + require('@/assets/login-bg.jpg') + ')' }"
    >
      <div class="container-fluid">
        <div class="row">
          <div class="col-sm-6 offset-sm-3" style="margin-top: 180px">
            <img src="../assets/unodc_logo.png" class="img-responsive" />
            <h2 class="title text-uppercase ml-5">
              Training Management
              <br />& Information System
            </h2>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-3 col-sm-12 bg-blue order-first order-md-2">
      <div class="container-fluid">
        <div class="row">
          <div class="col-sm-12 text-center" style="margin-top:110px">
            <ul>
              <li class="mb-5">
                <router-link to="/dashboard/Admin/adminDashboard" class="text-white text-uppercase">
                go to admin dashboard
                </router-link>
              </li>
               <li class="mb-5">
                <router-link to="/dashboard/Advisor/advisordashboard" class="text-white text-uppercase">
                go to advisor dashboard
                </router-link>
              </li>
               <li class="mb-5">
                <router-link to="dashboard/program-officer/todoList" class="text-white text-uppercase">
                go to program officer dashboard
                </router-link>
              </li>
               <li class="mb-5">
                 <a href="javascript:void(0)"  class="text-white text-uppercase">go to country representative dashboard</a>
               </li>
               <!-- <li class="mb-5">
                <router-link to="/dashboard/countryRepresentative/home" class="text-white text-uppercase">
                go to country representative dashboard
                </router-link>
              </li> -->
               <li class="mb-5">
                <router-link to="dashboard/Trainer/trainerPrevTraining" class="text-white text-uppercase">
                go to trainer dashboard
                </router-link>
              </li>
               <li class="mb-5">
                <router-link to="/dashboard/Trainee/traineeDashboard" class="text-white text-uppercase">
                go to trainee dashboard
                </router-link>
              </li>
            </ul>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      envVar: process.env.NODE_ENV,
      username: "",
      password: "",
      basepath: "",
      error: "",
      image: "../assets/images/login-bg.jpg"
    };
  },
  mounted() {
    this.isLoggedIn();
  },
  methods: {
    openLoading() {
      this.$vs.loading({
        type: "material"
      });
    },
    closeLoading() {
      this.$vs.loading.close();
    },
    loginForm(e) {
      e.preventDefault();
      // define -this- outside axios methods because -this- inside axios refers to the axios object, not the vue component:
      let self = this;
      let noAccess = "";
      self.openLoading();
      axios
        .post(`${process.env.VUE_APP_API_ENDPOINT}/login/user`, {
          username: this.username,
          password: this.password
        })
        .then(function(response) {
          self.closeLoading();
          if (response.data.success) {
            let isPermission = response.data.success.user.roles.permission;
            localStorage.setItem(
              "currentUser",
              JSON.stringify(response.data.success.user)
            );
            localStorage.setItem("isPermission", isPermission);
            localStorage.setItem("token", response.data.success.token);
            localStorage.setItem("auth", response.data.success.auth);

            if (localStorage.getItem("token") != null) {
              // This will redirect to admin dashboard
              if (
                isPermission == "admin" ||
                isPermission == "admin_expert" ||
                isPermission == "admin_officer" ||
                isPermission == "admin_associate" ||
                isPermission == "admin_assistant"
              ) {
                self.$router.push("/dashboard/Admin/adminDashboard"); // the router object
              }
              // This will redirect to Advisor/Senior Program Officer
              else if (isPermission == "advisor") {
                self.$router.push("/dashboard/Advisor/advisordashboard"); // the router object
              }
              // This will redirect to trainer dashboard
              else if (isPermission == "trainer") {
                self.$router.push("/dashboard/Trainer/trainerPrevTraining"); // the router object
              }
              // This will redirect to trainee
              else if (isPermission == "trainee") {
                self.$router.push("/dashboard/Trainee/traineeDashboard"); // the router object
              }
              // This will redirect to Program Officer
              else if (
                isPermission == "program_officer" ||
                isPermission == "program_assistant" ||
                isPermission == "program_coordinator" ||
                isPermission == "program_associate"
              ) {
                self.$router.push("/dashboard/program-officer/todoList"); // the router object
              }
              // This will redirect to Communucation Officer
              else if (isPermission == "comm_officer") {
                self.$router.push("/dashboard/communicationOfficer/home"); // the router object
              } else {
                noAccess = "Your are not authorized to access";
                self.error = noAccess;
              }
            }
          } else if (response.data.error) {
            self.error = response.data.error;
          }
        });
    },

    // This will check if user is already login or not
    isLoggedIn() {
      let currentUser = JSON.parse(localStorage.getItem("currentUser"));
      let self = this;
      let noAccess = "";
      if (localStorage.getItem("token") != null) {
        // This will redirect to admin dashboard
        if (
          currentUser.roles.permission == "admin" ||
          currentUser.roles.permission == "admin_expert" ||
          currentUser.roles.permission == "admin_officer" ||
          currentUser.roles.permission == "admin_associate" ||
          currentUser.roles.permission == "admin_assistant"
        ) {
          self.$router.push("/main-dashboard"); // the router object
        }
        // This will redirect to Advisor/Senior Program Officer
        else if (currentUser.roles.permission == "advisor") {
          self.$router.push("/dashboard/Advisor/advisordashboard"); // the router object
        }
        // This will redirect to trainer dashboard
        else if (currentUser.roles.permission == "trainer") {
          self.$router.push("/dashboard/Trainer/trainerPrevTraining"); // the router object
        }
        // This will redirect to trainee
        else if (currentUser.roles.permission == "trainee") {
          self.$router.push("/dashboard/Trainee/traineeDashboard"); // the router object
        }
        // This will redirect to Program Officer
        else if (
          currentUser.roles.permission == "program_officer" ||
          currentUser.roles.permission == "program_assistant" ||
          currentUser.roles.permission == "program_coordinator" ||
          currentUser.roles.permission == "program_associate"
        ) {
          self.$router.push("/dashboard/program-officer/todoList"); // the router object
        }
        // This will redirect to Communucation Officer
        else if (currentUser.roles.permission == "comm_officer") {
          self.$router.push("/dashboard/communicationOfficer/home"); // the router object
        } else {
          noAccess =
            "Your session has been expired. Try again to login please!";
          self.error = noAccess;
        }
      } else {
        return false;
      }
    }
  },
  created: function() {
    if (process.env.NODE_ENV == "development") {
      this.basepath = "/api";
      localStorage.setItem("BASE_PATH", "/api");
    } else if (process.env.NODE_ENV == "production") {
      this.basepath = process.env.VUE_APP_API_ENDPOINT;
      localStorage.setItem("BASE_PATH", process.env.VUE_APP_API_ENDPOINT);
    }
  }
};
</script>


<style scoped>
body,
html {
  height: 100%;
}

.bg {
  display: inline-flex;
  /* Full height */
  height: 100vh;
  /* Center and scale the image nicely */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.bg-blue {
  /* The image used */
  background-color: #00a6e4;
  float: right;
  /* Full height */
  height: 100vh;
}

.btn-black {
  background-color: #354146 !important;
  color: #fff !important;
}

::placeholder {
  text-align: center;
  color: #cdcdcd !important;
}
</style>
